import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchWorkoutsArgs,
  FetchWorkoutById,
} from '../api/types/workouts.types';

import { fetchWorkoutById, fetchWorkouts } from '../api/workouts.api';

export const workoutsQueryKeys = createQueryKeys('workouts', {
  fetchInfiniteWorkouts: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
    userUnitSettings,
  }: FetchWorkoutsArgs) => ({
    queryFn: async (context: any) =>
      fetchWorkouts({
        contentFilters,
        locale,
        organizationId,
        tableFilters: {
          ...tableFilters,
          offset: (context?.pageParam as string) || '1',
        },
        userUnitSettings,
      }),
    queryKey: [organizationId, tableFilters, contentFilters],
  }),
  fetchWorkoutById: ({
    id,
    locale,
    organizationId,
    userUnitSettings,
  }: FetchWorkoutById) => ({
    queryFn: () =>
      fetchWorkoutById({
        id,
        locale,
        organizationId,
        userUnitSettings,
      }),
    // No need to put locale in the queryKey, since exercise is returned with all translations, this includes tags too.
    queryKey: [organizationId, id, userUnitSettings],
  }),
  fetchWorkouts: ({
    contentFilters,
    locale,
    organizationId,
    tableFilters,
    userUnitSettings,
  }: FetchWorkoutsArgs) => ({
    queryFn: () =>
      fetchWorkouts({
        contentFilters,
        locale,
        organizationId,
        tableFilters,
        userUnitSettings,
      }),
    queryKey: [organizationId, tableFilters, contentFilters],
  }),
});
